export default __webpack_public_path__ + "static/media/success-blur.66c66b7d.png";